<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <div class="img">
        <img :src="item.icon1" alt="">
        <img v-show="item.url === $route.path" :src="item.icon2" alt="">
      </div>
      <div :style="{ color: item.url === $route.path ? '#2980f7' : '#282828' }">{{ item.name }}</div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
        {
          name: "首页",
          icon1: require('@assets/images/footimg/1-001.png'),
          icon2: require('@assets/images/footimg/1-002.png'),
          url: "/"
        },
        {
          name: "课程",
          icon1: require('@assets/images/footimg/2-001.png'),
          icon2: require('@assets/images/footimg/2-002.png'),
          url: "/category"
        },
        {
          name: "我的",
          icon1: require('@assets/images/footimg/4-001.png'),
          icon2: require('@assets/images/footimg/4-002.png'),
          url: "/user"
        }
      ]
    };
  },
  methods: {}
};
</script>

<style scoped>
  #footer {
    display: flex;
    flex-wrap: nowrap;
  }
    .item  {
      flex: 1;
      height: 100%;
    }
      .img {
        position: relative;
        width: 100%;
        height: 0.7rem;
      }
        .img img {
          height: 0.5rem;
          width: 0.5rem;
          position: absolute;
          bottom: 0.1rem;
          left: calc(50% - 0.25rem);
        }
</style>


